/**
 * GTM Logger Utility
 *
 * Conditional console logging for GTM events.
 * Logs are shown only when:
 * - Running on localhost
 * - URL has ?gtm_debug=1 parameter
 *
 * Usage:
 *   import { gtmLog } from './gtm-logger';
 *   gtmLog( 'Button click:', eventData );
 */

/**
 * Check if GTM logging is enabled (evaluated once at module load).
 */
const loggingEnabled = ( () => {
	const { search, hostname } = window.location;
	const urlParams = new URLSearchParams( search );

	return urlParams.get( 'gtm_debug' ) === '1' || hostname.includes( 'localhost' );
} )();

/**
 * Log GTM-related messages to console.
 *
 * Only outputs when on localhost or with ?gtm_debug=1 parameter.
 *
 * @param {...any} args Arguments to pass to console.log.
 */
export const gtmLog = ( ...args ) => loggingEnabled && console.log( '[GTM]', ...args ); // eslint-disable-line no-console
export const gtmError = ( ...args ) => loggingEnabled && console.error( '[GTM]', ...args ); // eslint-disable-line no-console
